/**
* 基础菜单 商品管理
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>会员配置</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" ref="formInline" :model="formInline" class="user-search">

      <el-form-item prop="platformType" label="平台">
        <el-select v-model="formInline.platformType" placeholder="不限">
          <el-option label="不限" value=""></el-option>
          <el-option v-for="item in PlatformTypeOptions" :key="item.value" :value="item.value"
                     :label="item.label"></el-option>
        </el-select>
      </el-form-item>


      <el-form-item>

        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button icon="el-icon-delete" type="info" @click="resetForm('formInline')">重置</el-button>
        <el-button icon="el-icon-delete" type="success" @click="handleEdit(1)">添加</el-button>

      </el-form-item>

    </el-form>
    <el-table id="educe-table" ref="multipleTable" stripe :data="listData" highlight-current-row v-loading="loading"
              element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
              @select-all="selectall"
              @select="select" border element-loading-text="拼命加载中" style="width: 100%; font-size: 18px;">

      <el-table-column prop="platformTypeDesc" align="center" label="平台" width="200">
      </el-table-column>
      <el-table-column prop="contentTypeDesc" align="center" label="会员类型" width="200">
      </el-table-column>
      <el-table-column prop="newPrice" align="center" label="会员价格" width="200">
      </el-table-column>
      <el-table-column prop="discount" align="center" label="优惠折扣" width="200">
      </el-table-column>
      <el-table-column prop="oldPrice" align="center" label="原价格" width="200">
      </el-table-column>


      <el-table-column prop="beginTime" label="创建时间" width="300">
        <template slot-scope="scope">
          <div> {{ scope.row.createTimeMills | timestampToTime }}</div>
          <br>


        </template>
      </el-table-column>


      <el-table-column align="center" prop="version" label="操作" width="250">
        <template slot-scope="scope">
          <el-button @click="handleEdit(2, scope.row)" type="primary">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--列表-->

    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" style="float: right; margin-right:0px; height: 50px; margin-top: 50px;"
                @size-change="handleSizeChange" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->


    <el-dialog :title="handIndex==1?'添加会员价格':'修改会员价格'" :visible.sync="dialogFormVisible" width="30%">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="130px" class="demo-ruleForm">
        <el-form-item label="平台:" prop="platformType">
          <el-select v-model="ruleForm.platformType" placeholder="请选择平台">
            <el-option v-for="item in PlatformTypeOptions" :key="item.value" :value="item.value"
                       :label="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="会员类型:" prop="contentType">
          <el-select v-model="ruleForm.contentType" placeholder="请选择会员类型">
            <el-option label="精英club会员" :value="1"></el-option>
            <el-option label="钻石会员" :value="3"></el-option>


          </el-select>
        </el-form-item>

        <el-form-item label="原价金额:" prop="oldPrice">
          <el-input type='Number' v-model="ruleForm.oldPrice" style="width: 300px;"
                    oninput="if(value.length >6) value=value.slice(0, 6)"
                    placeholder="请输入原价金额,0为免费"></el-input>
        </el-form-item>
        <el-form-item v-if="ruleForm.oldPrice>0" label="折扣后会员金额:" prop="newPrice">
          <el-input type='Number' oninput="if(value.length >6) value=value.slice(0, 6)" v-model="ruleForm.newPrice"
                    placeholder="折扣后会员金额"></el-input>
        </el-form-item>
        <div v-if='ruleForm.newPrice / ruleForm.oldPrice&&ruleForm.oldPrice&&ruleForm.oldPrice!=0'>限时优惠折扣: <span
          style="color: blue; font-size: 30px; font-weight: 600;">{{ (ruleForm.newPrice / ruleForm.oldPrice * 10).toFixed(1) }}</span> 折


        </div>

      </el-form>
      <div slot="footer" class="dialog-footer">

        <el-button @click="onCancel">取消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确定</el-button>
      </div>
    </el-dialog>


  </div>
</template>

<script>
import Vue from 'vue'
import { insertVipClubPriceConfig,updateVipClubPriceConfig } from '../../api/userMG'
import Axios from 'axios'
import { login } from "../../api"
let tokenId = localStorage.getItem('tokenId');


import Pagination from '../../components/Pagination'
import {PlatformTypeOptions} from "../../enums/userEnum";

export default {
  computed: {
    PlatformTypeOptions() {
      return PlatformTypeOptions
    }
  },
  data() {
    return {
      file_list: [],
      ssoServer: "",
      listData: '',
      ruleForm: {
        contentType: "",
        discount: "",
        id: "",
        newPrice: "",
        oldPrice: "",
        platformType: "",
      },

      hideUpload: false,
      ifnomoy: false,
      dialogFormVisible: false,
      dialogVisibles: false,
      options1234123: [],

      dialogImageUrl: '',
      dialogVisible: false,

      uploadDisabled: false,
      hideUpload_introduce: false,
      limitCount: 1,
      indexs: "",
      formInline: {
        platformType: "",

        current: 1,
        size: 20,
        // token: localStorage.getItem('logintoken')
      },

      dialogFormVisibleicn: false,
      activeName: '1',
      userlist: "",
      radio: "",


      checkList: [],
      options123: [],
      undataList: "",

      fileList: [],

      nshow: true, //switch开启
      fshow: false, //switch关闭
      importList: [],
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加banner',
      handIndex:"",
      editForm: {
        id: "",
        status: "",
        addressType: "1",
        addDeer: "",
        url: "",
        title: "",
        beginTime: "",
        type: "",
        path: [],
        orders: "",
        deptId: '',
        endTime: "",
      },

      // rules表单验证
      rules: {
        contentType: [
          { required: true, message: '会员类型不能为空', trigger: 'blur' }
        ],
        platformType: [
          { required: true, message: '平台不能为空', trigger: 'blur' }
        ],
        oldPrice: [
          { required: true, message: '原价金额不能为空', trigger: 'blur' }
        ],
        newPrice: [
          { required: true, message: '折扣后会员金额不能为空', trigger: 'blur' }
        ],

      },
      adder: "",


    }
  },

  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.ssoServer = Vue.prototype.GLOBAL.ssoServer

    let tokenId = localStorage.getItem('tokenId');
    this.adder = tokenId

    // this.getdata(this.formInline)
  },
  mounted() {
    this.formLIst()
  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    onCancel(){
           this.dialogFormVisible=false
           this.formLIst()
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {

              if(this.handIndex==1){
                if(this.ruleForm.oldPrice<this.ruleForm.newPrice){
                  this.$message({
          type: 'warning',
          message: '折扣后金额不得大于原价金额'
        })
        return
                 }
                // 添加
                if(this.ruleForm.oldPrice==0){
                  this.ruleForm.oldPrice=0
                  this.ruleForm.newPrice=0
                  this.ruleForm.discount=0
                }else{
                  this.ruleForm.discount = (this.ruleForm.newPrice / this.ruleForm.oldPrice * 10).toFixed(1)
                }



          insertVipClubPriceConfig(this.ruleForm).then(res => {
            if (res.code == 0) {
              this.$message({
                type: 'success',
                message: '添加成功'
              })

              this.ruleForm.contentType = "",
                this.ruleForm.discount = "",
                this.ruleForm.newPrice = "",
                this.ruleForm.oldPrice = "",
                this.ruleForm.platformType = "",
                this.dialogFormVisible=false
                this.formLIst()


            } else {

            }
            // console.log(res);

          })
              }else{
                // 修改

                if(this.ruleForm.oldPrice==0){
                  this.ruleForm.oldPrice=0
                  this.ruleForm.newPrice=0
                  this.ruleForm.discount=0
                }else{
                  this.ruleForm.discount = (this.ruleForm.newPrice / this.ruleForm.oldPrice * 10).toFixed(1)
                }
                if(this.ruleForm.newPrice>this.ruleForm.oldPrice){
                  this.$message({
          type: 'warning',
          message: '折扣后金额不得大于原价金额'
        })
        return
                 }


                updateVipClubPriceConfig(this.ruleForm).then(res => {
            if (res.code == 0) {
              this.$message({
                type: 'success',
                message: '修改成功'
              })

              this.ruleForm.contentType = "",
                this.ruleForm.discount = "",
                this.ruleForm.newPrice = "",
                this.ruleForm.oldPrice = "",
                this.ruleForm.platformType = "",
                this.dialogFormVisible=false
                this.formLIst()


            } else {

            }
            // console.log(res);

          })


              }





        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    close() {
      this.ifnomoy = false
      this.ruleForm.accountIds = "",
        // this.ruleForm.activityId="",
        this.ruleForm.amount = "",
        this.ruleForm.type = ""

    },

    goBake() {
      this.$router.push({
        path: "/machine/Setevent",
      })
    },
    onresource(item) {
      if (item == '1') {
        this.ifnomoy = false
      } else if (item == '2') {
        this.ifnomoy = true
      }


    },


    uploadSectionFile(f, g) {
      if (g.length >= 1) {
        this.uploadDisabled = true;
      }


      this.hideUpload = true;
    },

    handleAvatarSuccess(res, file) {

      // console.log(res.data,file);

      this.editForm.path = res.data
      this.hideUpload = false;
    },

    // 添加图片
    handleRemove(file, fileList) {

      this.uploadDisabled = false;
      console.log(file, fileList);
    },

    //添加

    // 确定审核
    OndialogVisible() {

      Axios({
        method: 'post',
        url: this.ssoServer + '/api/platform-nick-name-check/operate',
        headers: {
          tokenId: this.adder
        },
        data: {
          //   appearanceScore:this.radio,
          accountIds: this.importList,
          operatorUserId: 1,

        }
      }).then(res => {
        if (res.data.code == 999) {
          setTimeout(() => {
            localStorage.removeItem('tokenId')

            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '登录过期,请重新登录'
            })
          }, 1000)
        }
        if (res.data.code == 0) {
          this.dialogVisible = false
          this.$message({
            type: 'success',
            message: '审核成功'
          })
          this.formLIst()
        }
      })





    },


    handleCheckedCitiesChange() {
      console.log(this.checkList);
    },
    caozClick() {
      if (this.importList.length == 0) {
        this.$message({
          type: 'warning',
          message: '请选择要审核的用户'
        })
        return

      } else {
        this.dialogVisible = true
        console.log('1111');
      }

    },

    handleClick(tab, event) {
      //  return  console.log(this.activeName);
      if (this.activeName == 1) {
        this.formInline.status = 1
        this.formLIst()
      } else if (this.activeName == 2) {
        this.formInline.status = 2
        this.formLIst()
      } else if (this.activeName == 3) {
        this.formInline.status = 3
        this.formLIst()
      }

    },

    getAddress() {
      Axios({
        method: 'get',
        url: this.ssoServer + '/api/common/getAddressList1',
        headers: {
          tokenId: this.adder
        },
      }).then(res => {
        console.log("getAddressList", res.data.data);
        this.options123 = res.data.data

      })
    },
    getAddresss() {
      Axios({
        method: 'get',
        url: this.ssoServer + '/api/common/getAddressList1',
        headers: {
          tokenId: this.adder
        },
      }).then(res => {
        // console.log("getAddressList", res.data.data);
        this.options1234123 = res.data.data

      })
    },

    change1(e) {
      console.log("change1", e);
      if (e.length === 1) {
        this.$message({
          type: 'error',
          message: '请选择详细地址'
        })
      }
      if (e.length === 2) {
        this.formInline.registerAddress = e[1];
      }
    },

    handleEdit(index, row) {

       this.handIndex= index

      if (index == 2) {

        this.ruleForm = row
        this.dialogFormVisible = true
        return

      } else {
          this.ruleForm.contentType = "",
          this.ruleForm.discount = "",
          this.ruleForm.newPrice = "",
          this.ruleForm.oldPrice = "",
          this.ruleForm.platformType = ""
          this.dialogFormVisible = true
      }



    },
    addOnclick(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '编辑banner'
        this.editForm.roleId = row.roleId
        this.editForm.systemNo = row.systemNo
        this.editForm.roleNo = row.roleNo
        this.editForm.roleName = row.roleName
      } else {
        this.title = '添加banner'
        this.editForm.roleId = ''
        this.editForm.systemNo = ''
        this.editForm.roleNo = ''
        this.editForm.roleName = ''
      }
      // this.indexs=1
      // if (this.indexs==1) {
      //   this.title='添加banner'
      //   this.editFormVisible=true
      // }

    },
    selectalls(rows) {
      this.userlist = rows
      this.indexs = 2
      if (this.indexs == 2) {
        this.title = '编辑banner'

        let add = String(rows.type)
        //  return  console.log(add);

        this.editFormVisible = true
        this.editForm = this.userlist
        this.editForm.type = add
        this.editForm
      }

      // this.undataList =rows

      console.log(rows);
    },

    onChanges(e) {
      this.formInline.activityAddressCode = e[1]
      // console.log( this.formInline.registerAddress);
    },
    selectall(val) {
      console.log(val);

      let data = []
      // this.importList=''
      val.forEach((item) => {
        data.push(item.id)
        this.importList = data
        console.log(this.importList);

      })

      // this.importList
      console.log(val);
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 导出数据
    imporList() {
      if (this.importList.length == 0) {

        this.$message({
          type: 'warning',
          message: '请选择要导出的数据'
        })
        return

      } else {
        Axios({
          method: 'post',

          url: this.ssoServer + '/api/platform-account/exportExcel',
          headers: {
            tokenId: this.adder
          },
          data: {
            accountIds: this.importList
          },
          responseType: 'blob'
        }).then(res => {
          const link = document.createElement('a') // 创建a标签
          const blob = new Blob([res.data], { type: 'application/vnd.ms-excel;charset=UTF-8' })
          link.href = window.URL.createObjectURL(blob)
          const filename = res.headers['content-disposition'].split('filename=')[1]
          link.download = decodeURIComponent(filename) // 如果需要自定义下载文件名，则手动设置
          link.click()
          window.URL.revokeObjectURL(link.href)
        })


      }




    },
    select(selection, row) {

      let data = []
      // this.importList=''
      selection.forEach((item) => {
        data.push(item.id)
        this.importList = data
        console.log(this.importList);

      })

      // console.log(this.importList);
      // console.log(selection);
    },

    formLIst() {
      // let accountListReqVO= this.formInline
      Axios({
        method: 'get',

        url: this.ssoServer + '/api/vipClub/getVipClubPriceConfigList',
        headers: {
          tokenId: this.adder
        },
        params: this.formInline
      }).then(res => {
        if (res.data.code == 999) {
          setTimeout(() => {
            localStorage.removeItem('tokenId')

            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '登录过期,请重新登录'
            })
          }, 1000)
        }
        this.listData = res.data.data.list

        this.pageparm.currentPage = this.formInline.current
        this.pageparm.pageSize = this.formInline.size
        this.pageparm.total = res.data.data.total
        console.log(res);
      })

    },
    formatData(row, column, cellValue, index) {

      //把传过来的日期进行回炉重造一下，又创建了一个js的 Date对象，进行重新构造，转为String字符串
      //最终返回 s 就可以了
      var s = new Date(cellValue).toLocaleString();
      return s;

      // 测试参数含义：不知道参数是什么含义的就打印出来
      // console.log(row)     	//拿到一行的所有信息，要拿到具体信息,只需要row.XXX 就可以了
      // console.log(column)  	//拿到列的信息
      // console.log(cellValue) //拿到单元格数据，拿到时间 2022-03-18T01:46:08.000+00:00
      // console.log(index)     //拿到索引
    },

    // 获取公司列表
    getdata(parameter) {
      this.loading = true
      // 模拟数据开始
      let res = {
        code: 0,
        msg: null,
        count: 5,

      }
      this.loading = false

      // 模拟数据结束

      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      deptList(parameter)
      // .then(res => {
      //   console.log(res);
      //   this.loading = false
      //   if (res.success == false) {
      //     this.$message({
      //       type: 'info',
      //       message: res.msg
      //     })
      //   } else {
      //     this.listData = res.data
      //     // 分页赋值
      //     this.pageparm.currentPage = this.formInline.current
      //     this.pageparm.pageSize = this.formInline.size
      //     this.pageparm.total = res.count
      //   }
      // })
      // .catch(err => {
      //   this.loading = false
      //   this.$message.error('菜单加载失败，请稍后再试！')
      // })
    },
    handleSizeChange(e) {
      // reru console.log(e.pageSize);
      this.formInline.size = e.pageSize
      this.formInline.current = e.currentPage

      this.formLIst()
      // console.log(e);
    },
    // 分页插件事件
    callFather(parm) {
      console.log(parm);

      this.formInline.size = parm.pageSize
      this.formInline.current = parm.currentPage
      this.formLIst()
    },
    // 搜索事件
    search() {
      this.formInline.current = 1
      this.formLIst()

      // console.log(this.formInline);
      // this.getdata(this.formInline)
    },


    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deptDelete(row.deptId)
            .then(res => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '公司已删除!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('公司删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog(editForm) {
      this.fileList = []
      // this.$refs[editForm].resetFields();
      this.editFormVisible = false
    }
  }
}
</script>

<style>
.disabled .el-upload--picture-card {
  display: none !important;
}




.dialogForm {
  width: 100%;
  /* height: 600px; */
  /* background-color: red; */
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  .dialogFormChl {
    margin-top: 20px;
    /* flex: 1; */
    width: 23%;
    border-radius: 15px;
    /* border: 1px solid #ccc; */
    height: 300px;

  }

  .dialogFormChl img {
    width: 100%;
    height: 200px;
  }
}

.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/machine/vipConfiguration.vue